// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
// @ts-ignore
import {ga_track_download_send} from '../ga.js';
// @ts-ignore
import {get_exe_link, download_file, get_filename} from '../install_util.js';
// @ts-ignore
import {get_json} from '/util/storage.js';
import {use_client_hints} from '../client_hints';
import {guess_os_and_version} from '../client_hints_global';
// @ts-ignore
import {App_context} from '../context.js';
import {use_qs} from '../lib/use_qs';
// @ts-ignore
import {parse} from 'zurl';
import hopt from 'hola_opt';
import zutil from 'zutil';

interface i_download_rule {
    path?: string[];
    tmpl: string;
}
interface i_replace_opt {
    qs: object_of<string>;
    pathname: string;
    rules?: i_download_rule[];
}
type t_replace_link = (link: string, opt: i_replace_opt)=>string;
const replace_link: t_replace_link = (link, opt)=>{
    const {pathname, rules = [], qs} = opt;
    const rule = rules.find(v=>!v.path || v.path.includes(pathname));
    if (!rule)
        return link;
    const {host, directory, file, search} = parse(link);
    const filepath = directory.split('/').filter(v=>!!v).join('/');
    return rule.tmpl
        .replace('{domain}', host)
        .replace('{file}', encodeURIComponent(file))
        .replace('{search}', encodeURIComponent(search))
        .replace('{filepath}', encodeURIComponent(filepath))
        .replace('{filesearch}', encodeURIComponent(file+search))
        .replace(/\{qs:([\w\d]+)\}/, (_, p1)=>qs[p1] || '');
};

interface i_use_download_opt extends object_of<any> {
    pref?: string;
    need_agree?: boolean;
    filename?: string;
}
export const use_download = (props:i_use_download_opt = {})=>{
    use_client_hints();
    const {need_agree, pref, filename, ...download_options} = props;
    const sys = guess_os_and_version();
    // @ts-ignore
    const {has_svc, svc_info, inited} = useContext(App_context);
    const [try_again, set_try_again] = useState(0);
    const [agree, set_agree] = useState(false);
    const {pathname} = useLocation();
    const qs = use_qs();
    const last_options = useRef<typeof download_options>();
    const download_fn = useRef('');
    const d_tmpl_conf = zutil.get(hopt, 'www_hola.download_tmpl');
    const d_tmpl_enabled = d_tmpl_conf && (d_tmpl_conf.enabled ||
        qs.debug_download_tmpl);
    const d_rules = d_tmpl_enabled && d_tmpl_conf.rules;
    const d_opt = d_tmpl_enabled && d_tmpl_conf.opt;
    const download = (opt?: typeof download_options)=>{
        last_options.current = opt;
        download_fn.current = 'download';
        if (need_agree && !opt?.agree)
            return;
        let has_svc_ = has_svc;
        let svc_info_ = svc_info;
        if (!inited)
        {
            const svc_info_storage = get_json('unblock.svc.info');
            if (!svc_info_storage)
                return setTimeout(()=>set_try_again(try_again+1), 100);
            has_svc_ = true;
            svc_info_ = svc_info_storage;
            console.log(svc_info_);
        }
        let url: string, original_url: string;
        url = original_url = get_exe_link({has_svc: has_svc_,
            svc_info: svc_info_, ...download_options, ...d_opt, ...opt});
        if (d_rules)
            url = replace_link(original_url, {pathname, rules: d_rules, qs});
        ga_track_download_send(sys.os=='macos' ? 'dmg' : 'exe',
            'no_extension', url, null, undefined, {original_url});
        download_file(url, filename);
        if (opt?.cb)
            opt.cb();
        need_agree && set_agree(false);
    };
    const download_br = (opt?: typeof download_options)=>{
        download_fn.current = 'download_br';
        last_options.current = opt;
        if (need_agree && !opt?.agree)
            return;
        let url, original_url;
        url = original_url = get_exe_link({...download_options, ...d_opt,
            ...opt, hola_browser: true});
        if (d_rules)
            url = replace_link(original_url, {pathname, rules: d_rules, qs});
        ga_track_download_send('exe',
            `browser_from_${pref||'hp'}`, url, null, undefined, {
                hola_browser: true,
                pref,
                original_url,
            });
        download_file(url);
        if (opt?.cb)
            opt.cb();
        need_agree && set_agree(false);
    };
    const filename_fn = useCallback((opt: typeof download_options)=>{
        return get_filename({...download_options, ...opt, pref});
    }, [pref, download_options]);
    const fns = {download, download_br};
    useEffect(()=>{
        if (try_again)
            download(last_options.current);
    }, [try_again]);
    useEffect(()=>{
        if (need_agree && agree)
            fns[download_fn.current]({...last_options.current, agree: true});
    }, [need_agree, agree]);
    return {download, download_br, do_agree: ()=>set_agree(true),
        get_filename: filename_fn};
};
